/**
 * HTML attributes that encourage the correct mobile soft keyboard.
 * iOS Safari also respects `pattern="[0-9]*"` on tel/text fields for a numeric pad.
 */

export const phoneInputMobileProps = {
  type: 'tel' as const,
  inputMode: 'numeric' as const,
  autoComplete: 'tel-national' as const,
  pattern: '[0-9]*',
  enterKeyHint: 'done' as const,
};

/** Typed dates (DD/MM/YYYY) — numeric pad; native picker via SmartDateInput calendar control. */
export const dateTextInputMobileProps = {
  inputMode: 'numeric' as const,
  autoComplete: 'off' as const,
  pattern: '[0-9/\\-]*',
  enterKeyHint: 'done' as const,
};
